module.exports = __webpack_public_path__ + "static/media/databases1.72454526.svg";